<template>
  <div>
    <div class="tab-pane-body-advanced">
      <el-form :model="courseInfo" ref="advancedSettingForm" label-position="right" label-width="112px">
        <el-form-item label="难易程度" prop="type">
          <el-select v-model="courseInfo.type" filterable>
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="连载状态" prop="serial">
          <el-radio-group v-model="courseInfo.serial">
            <el-radio :label="1" border>更新中</el-radio>
            <el-radio :label="2" border>已完结</el-radio>  
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品状态" prop="status">
          <el-radio-group v-model="courseInfo.status">
            <el-radio :label="10" border>下架</el-radio>
            <el-radio :label="20" border>上架</el-radio>  
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="order">
          <el-input-number v-model="courseInfo.order" :max="100000000" controls-position="right"></el-input-number>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
  components: {

  },
  props: {
    // 课程信息
    courseInfo: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  // 定义属性
  data() {
    return {
      typeList:[
        {name:'入门',value:1},
        {name:'初级',value:2},
        {name:'中级',value:3},
        {name:'高级',value:4}
      ]
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {

  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 基本信息表单验证
    formValidate() {
      this.$refs['advancedSetForm'].validate((valid) => {
        if (valid) {
          this.$emit('formSubmit',this.courseInfo)
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    }
    
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    
  }
}
</script>

<style lang='stylus'>
  .tab-pane-body-advanced
    padding 16px
    width 60%
    margin-bottom 48px
    .el-select
      width 100%
    .el-input-number
      width 100%
      .el-input__inner
        text-align left  
</style>